<div class="pec-search-panel">
  <div class="pec-search-bar">
    <svg
      class="search-svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.35-4.35" />
    </svg>
    <input
      class="search-input"
      type="text"
      placeholder="Cerca messaggi, mittenti, protocolli…"
      [ngModel]="state.query()"
      (ngModelChange)="onQueryChange($event)"
      (focus)="onFocus()"
      (keydown.enter)="onEnter()"
    />
    @if (state.query()) {
      <button class="search-clear" (click)="clearQuery()">
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
        >
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    }
  </div>

  @if (isOpen()) {
    <div class="pec-search-dropdown">
      <div class="pec-search-chips">
        @for (campo of campiRicerca; track campo.value) {
          <button
            class="pec-search-chip"
            [class.is-active]="isFieldSelected(campo.value)"
            (click)="toggleField(campo.value)"
          >
            {{ campo.label }}
          </button>
        }
      </div>

      @if (state.query().trim()) {
        <div class="pec-search-section">
          <div class="pec-search-section-title">{{ searchSectionTitle() }}</div>
          @if (senderSuggestions().length === 0) {
            <div class="pec-search-empty">Nessun indirizzo trovato</div>
          } @else {
            @for (sender of senderSuggestions(); track sender.mittente) {
              <button class="pec-search-sender" (click)="pickSuggestedSender(sender)">
                @if (isFieldSelected('MITTENTE') || isFieldSelected('DESTINATARIO')) {
                  <span class="pec-search-sender-name">{{ sender.nomeMittente || sender.mittente }}</span>
                }
                <span
                  class="pec-search-sender-email"
                  [class.pec-search-sender-email-primary]="
                    !isFieldSelected('MITTENTE') && !isFieldSelected('DESTINATARIO')
                  "
                  >{{ sender.mittente }}</span
                >
              </button>
            }
          }
        </div>

        <div class="pec-search-section">
          <div class="pec-search-section-title">Risultati</div>
          @if (loading()) {
            <div class="pec-search-empty">Ricerca in corso…</div>
          } @else if (results().length === 0) {
            <div class="pec-search-empty">Nessun risultato</div>
          } @else {
            @for (msg of results(); track msg.id) {
              <button
                class="pec-search-result"
                [class.is-disabled]="!isResultClickable(msg)"
                (click)="isResultClickable(msg) && openResult(msg)"
              >
                <span class="pec-search-result-main">
                  <span class="pec-search-result-subject">{{ msg.oggetto || '(nessun oggetto)' }}</span>
                  <span class="pec-search-result-from">{{ msg.nomeMittente || msg.mittente }}</span>
                </span>
                <span class="pec-search-result-badges">
                  @if (msg.etichetta) {
                    <span class="pec-search-etichetta-chip" [title]="msg.etichetta.nomeEtichetta">
                      {{ msg.etichetta.nomeEtichetta }}
                    </span>
                  }
                  @if (msg.tipo != 'INBOX') {
                    <span class="pec-search-result-badge" [class]="'pec-search-badge-' + msg.tipo.toLowerCase()">
                        {{ sezioneLabel[msg.tipo] }}
                    </span>
                  }
                </span>
              </button>
            }
          }
        </div>
      }
    </div>
  }
</div>
